import { priceDefaultSettings } from '@elfsight/widget-ui';
import {
  discountDefaultSettings,
  oldPriceDefaultSettings
} from '../../constants';
import { type Column } from '../../types';

export const defaultColumn: Column = {
  id: '',
  picture: null,
  title: '',
  titleCaption: '',
  highlightLabel: '',
  features: [],
  price: {
    ...priceDefaultSettings,
    pricingModel: 'custom',
    customPrice: ''
  },
  priceCaption: '',
  oldPrice: oldPriceDefaultSettings,
  discount: discountDefaultSettings,
  buttonText: '',
  buttonCaption: '',
  buttonLink: {
    type: 'url',
    value: '',
    rawValue: '',
    target: '_blank'
  },
  buttonAction: 'openLink',
  primaryColor: 'transparent',
  visible: true
};
